module.exports = __webpack_public_path__ + "static/media/about_us_our_partners_store.001d3d54.png";